import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ArrowIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="Sort"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "5.5"}
      height={height || "9.5"}
      viewBox="0 0 5.5 9.5"
    >
      <path
        id="caret-down"
        d="M11.665,195.5h4.76a.422.422,0,0,0,.261-.708l-2.379-2.671a.343.343,0,0,0-.524,0L11.4,194.792A.422.422,0,0,0,11.665,195.5Z"
        transform="translate(-11.295 -192)"
        fill={color || "#707070"}
      />
      <path
        id="caret-down-2"
        data-name="caret-down"
        d="M11.665,192h4.76a.422.422,0,0,1,.261.708l-2.379,2.671a.343.343,0,0,1-.524,0L11.4,192.708A.422.422,0,0,1,11.665,192Z"
        transform="translate(-11.295 -186)"
        fill={color || "#707070"}
      />
    </svg>
  );
}
